/**
 * @requires ./frc.js
 */

frc.modules.contact = function($module) {
	var self = this;
	self.config = {
		"commentCategories": [ // Make sure these options correspond to the ones in config.php
			{"Restaurant Experience": 0},
			{"Media & PR": 1},
			{"Donation Requests": 2},
			{"Location Suggestions": 3},
			{"Group Dining Inquiries": 'pdr'},
			{"Careers": 'careers'}
		]
	};
	self.data = {
		"$module": null,
		"enabled": true
	};

	if((typeof $module)=="string"){
		$module = $($module);
	}

	self.data.$module = $module;

	self.renderDropdownField = function(field, params){
		params = jQuery.extend({
			firstAsPlaceholder: true,
			nativeOnMobile: true,
			validateOnSubmit: true,
			forceRenderBelow: true,
			show: 6,
		}, params || {});
		field.Selecta(params);
	};

	self.init = function() {
		var submitted = $module.text().indexOf("Thank you for your message. It has been sent.") > -1;
		if(submitted){
			$module.attr("data-submitted", "true");

		} else {
			$module.attr("data-submitted", "false");

			self.data.fields = {
				"name": $module.find(".cf_name"),
				"email": $module.find(".cf_email"),
				"phone": $module.find(".cf_phone"),
				"date": $module.find(".cf_date"),
				"commentCategory": $module.find(".cf_commentcategory"),
				"commentCategoryTitle": $module.find(".cf_commentcategorytitle"),
				"location": $module.find(".cf_commentlocation"),
				"comments": $module.find(".cf_comments"),
				"submitButton": $module.find("input[type=\"submit\"]")
			};

	 		frc.api.brand.getLocations(function(response) {
	 			var locations = [];
	 			if (response.data.length) {
	 				for (var i = 0; i < response.data.length; i++) {
	 					locations.push(response.data[i].location.displayName);
	 				}
	 				locations.sort();

					for (i = 0; i < locations.length; i++) {
						self.data.fields.location.append('<option value="'+ locations[i] +'">'+ locations[i] +'</option>');
					}
					self.data.fields.location.on('selecta-init', function(e, o) {
						o.$container.addClass('s-cf_commentlocation');
					}).Selecta({ nativeOnMobile: true, firstAsPlaceholder: true });

	 			} else {
	 				self.data.fields.location.parent().css('display', 'none');
	 			}

				// Comment category
				self.config.commentCategories.forEach(function(category){
					var $option = $('<option></option>');
					jQuery.each(category, function(lbl, val) {
						$option.attr("value", $.trim(val)).text($.trim(lbl));
						self.data.fields.commentCategory.append($option);
					});
				});

				self.data.fields.commentCategory.on('change', function() {
				if ($(this).val() == 'pdr') {
					$('.contact-form, .careers-message').removeClass('open');
					$('.pdr-message').addClass('open');
				}
				else if ($(this).val() == 'careers') {
					$('.contact-form, .pdr-message').removeClass('open');
					$('.careers-message').addClass('open');
				}
				else {
					$('.pdr-message, .careers-message').removeClass('open');
					$('.contact-form').addClass('open');
					var index = $(this).prop('selectedIndex');
					self.data.fields.commentCategoryTitle.val($(this).find('option').eq(index).text());
				}
			});

			self.renderDropdownField(self.data.fields.commentCategory, { "class": "s-cf_commentcategory" });
/*
				self.data.fields.commentCategory.on('selecta-init', function(e, o) {
					o.$container.addClass('s-cf_commentcategory');
				}).Selecta({ nativeOnMobile: true, firstAsPlaceholder: true }); */

				// Other
				self.data.fields.date.datepicker();

				self.data.fields.commentCategory.on('change', function() {
					var commentIdx = $(this).prop('selectedIndex');
					self.data.fields.commentCategoryTitle.val($(this).find('option').eq(commentIdx).text());
				});

	 		});

	 		$module.find("[aria-required=\"true\"]").attr("required","required");
	 		self.data.fields.phone.attr("pattern", "^(([\\+]?[1]?[\\s]?(\\d{3}|\\(\\d{3}\\)))[\\-|\\s]?\\d{3}[\\-|\\s]?\\d{4})?$");

			// Validation
			self.data.fields.name.on("invalid", function(e) {
				e.target.setCustomValidity("Please fill out this field");
			});
			self.data.fields.comments.on("invalid", function(e) {
				e.target.setCustomValidity("Please fill out this field");
			});
			self.data.fields.location.on("invalid", function(e){
				e.target.setCustomValidity("Please choose a location");
			});
			self.data.fields.phone.on("invalid", function(e){
				e.target.setCustomValidity("Please provide a phone number in xxx-xxx-xxxx format");
			});
			self.data.fields.email.on("invalid", function(e) {
				e.target.setCustomValidity("Please enter a valid email address");
			});
			self.data.fields.commentCategory.on("invalid", function(e) {
				e.target.setCustomValidity("Please choose a category");
			});

			// Clear field's error message if its value has changed
			for(i in self.data.fields){
				self.data.fields[i].on("change", function(e){
					e.target.setCustomValidity("");
				});
			}

	 		$module.find("form").on("submit", function(e){
	 			self.data.fields.submitButton.attr('disabled', true);
	 			self.data.$module.addClass('busy');
	 			var $form = $(this);

	 			if (!frc.utilities.validateForm($form)) {
	 				e.preventDefault();
	 				self.data.$module.removeClass('busy');
	 				self.data.fields.submitButton.attr('disabled', false);
	 			}
	 		});
		}

		$(window).trigger('contact-form-loaded', $('section.form'));

	}

	self.init();
	return self;

}
